// eslint-disable-next-line no-unused-vars
import UserRepository from '../../../domain/repositories/UserRepository';
// eslint-disable-next-line no-unused-vars
import ChatUser from '../../../domain/entities/ChatUser';

class GetUsersUseCase {
    /**
     * @param {UserRepository} userRepository
     */
    constructor(userRepository) {
        this.userRepository = userRepository;
    }

    /**
     * @returns {Promise<ChatUser[]>}
     */
    async execute() {
        return this.userRepository.getUsers();
    }
}

export default GetUsersUseCase;
